import { useEffect, useState } from "react";
import api from "@/lib/api";

// Rendered only when the server reports Microsoft work-account sign-in as enabled (public booleans; off by default).
// Navigates to the fixed server start route - the browser never builds the Microsoft URL itself.
export function MicrosoftSignIn() {
  const [status, setStatus] = useState(null);
  const [failed] = useState(() => new URLSearchParams(window.location.search).get("microsoft") === "failed");
  useEffect(() => { api.get("/auth/microsoft/status").then((r) => setStatus(r.data)).catch(() => setStatus(null)); }, []);
  if (!status?.enabled && !failed) return null;
  return (
    <div data-testid="microsoft-signin" className="mt-4 border-t border-jigsaw-border pt-4">
      {failed && <p data-testid="microsoft-signin-failed" className="mb-2 text-[12px] text-jigsaw-danger">Microsoft sign-in was not completed. Only pre-approved Jigsaw staff accounts can use it - contact a Jigsaw Admin if you expected access.</p>}
      {status?.enabled && (
        <a data-testid="microsoft-signin-button" href={`${process.env.REACT_APP_BACKEND_URL}/api/auth/microsoft/start`}
           className="inline-flex w-full items-center justify-center gap-2 rounded-md border border-jigsaw-navy/20 bg-white px-3 py-2 text-sm font-medium text-jigsaw-navy hover:bg-[#F5F7FA]">
          <span aria-hidden className="grid h-4 w-4 grid-cols-2 gap-[1px]"><i className="bg-[#F25022]" /><i className="bg-[#7FBA00]" /><i className="bg-[#00A4EF]" /><i className="bg-[#FFB900]" /></span>
          Sign in with your Jigsaw Microsoft work account
        </a>
      )}
      <p className="mt-1 text-[11px] text-jigsaw-muted">Jigsaw staff only. Clients and suppliers continue to sign in with an e-mail code.</p>
    </div>
  );
}
